import { SnContentType } from './content-type';

export function getContentTypeIcon(contentType: SnContentType): string {
  switch (contentType) {
    case SnContentType.Camera:
      return 'videocam';
    case SnContentType.Location:
      return 'location_city';
    case SnContentType.Grid:
      return 'apps';
    case SnContentType.Tag:
      return 'local_offer';
    case SnContentType.Team:
      return 'group';
    case SnContentType.User:
      return 'person';
    case SnContentType.Alarm:
      return 'warning';
    case SnContentType.Tip:
      return 'panorama';
    case SnContentType.GooglePlace:
      return 'place';
    case SnContentType.GoogleAddress:
      return 'place';
    case SnContentType.Recording:
      return 'local_movies';
    case SnContentType.Avl:
      return 'local_police';
    case SnContentType.Cad:
      return 'report_problem';
  }
}
